import { Workstation } from '@/modules/Workstation'
import { CombinedLogs } from '@/modules/CombinedLogs'
import { Mileage } from '@/modules/Mileage'
import { useAuthStore } from '@/store/auth-store'
import { RadialBackground } from '@/ui/RadialBackground'
import { useShowEndOfShiftModal } from '../hooks/useShowEndOfShiftModal'
import { useShowConfirmDetailsModal } from '../hooks/useShowConfirmDetailsModal'
import { useWorkstationStore } from '@/modules/Workstation/store'

import styles from './Dashboard.module.scss'

export const ControllerDashboard = () => {
    const { routes } = useWorkstationStore()
    const { xUserShiftId } = useAuthStore()
    useShowEndOfShiftModal()
    useShowConfirmDetailsModal()

    return (
        <>
            {xUserShiftId ? (
                <section className={styles.root}>
                    <div className={styles.header}>
                        <Workstation />
                        <Mileage displayed={!!routes.length} />
                    </div>

                    <CombinedLogs />
                </section>
            ) : (
                <RadialBackground className={styles.background} variant={'main'}>
                    <section className={styles.rootUnauthorized}>
                        <div className={styles.header}>
                            <Workstation />
                            <Mileage displayed={!!routes.length} />
                        </div>
                    </section>
                </RadialBackground>
            )}
        </>
    )
}
